import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { EPInput } from "@/comp";
import { AutoSaverFormItem } from "./AutoSaverFormItem";
import { getTaskFieldMetadata } from "./constants";
import { useTask } from "./Provider";
import { StageTaskType } from "@/store/Lifecycle/constants";
import { computeValidateStatus } from "./utils";

export const LinkField = observer(() => {
    const task = useTask<StageTaskType.Link>();
    const { name, value, placeholder, label, validateStatus, help, isSaving, isReadOnly, required } = getTaskFieldMetadata(task);
    const { t } = useTranslation();

    const computedValidateStatus = computeValidateStatus(value, validateStatus);

    return (
        <AutoSaverFormItem 
            name={name} 
            label={label}
            initialValue={value} 
            className='stage-task-input-field'
            rules={[{
                validator: (_, value) => {
                    const trimmedValue = value?.trim();
                    
                    if (!trimmedValue) {
                        return required ? Promise.reject(new Error(t('Please add a valid link'))) : Promise.resolve();
                    }
                    
                    const hasDot = /^[^.].*\.[^.].*$/.test(trimmedValue);
                    if (!hasDot) {
                        return Promise.reject(new Error(t('Please add a valid link')));
                    }
                    
                    try {
                        new URL(trimmedValue.includes('://') ? trimmedValue : `http://${trimmedValue}`);
                        return Promise.resolve();
                    } catch {
                        return Promise.reject(new Error(t('Please add a valid link')));
                    }
                },
            }]}
            hasFeedback
            validateStatus={computedValidateStatus}
            help={help ? t(help) : undefined}
            required={required}
        >
            <EPInput 
                className='stage-task-input'
                value={value} 
                placeholder={t(placeholder)}
                disabled={isReadOnly || isSaving}
            />
        </AutoSaverFormItem>
    );
});